// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OjD_","colMin":"styles_colMin__213su"};